const allProjects = [

    {
        "id": "books-co",
        "name": "Books & Co.",
        "gifWidth": "650",
        "tagline": "An interactive book resource application where users can search for new books to read and track their reading history",
        "features": [
            "- Search for any book by title, author or genre",
            "- Join a book club and sharing recommendations",
            "- Rate and write a review or react to other users' reviews",
        ],
        "github": "https://github.com/nathalia-lt/books-co/",
        "deploy": "https://books-co.herokuapp.com/",
        "type": "success"
    },

    {
        "id": "eventhunter",
        "name": "EventHunter",
        "gifWidth": "800",
        "tagline": "A webpage that utilizes a Ticketmaster API to provide information about events happening in the United States.",
        "features": [
            "- Search for any specific event",
            "- Save favourite events for later viewing",
            "- Access links to buy tickets"
        ],
        "github": "https://github.com/nathalia-lt/eventhunter",
        "deploy": "nathalia-lt.github.io/eventhunter",
        "type": "info"
    },

    {
        "id": "luatide",
        "name": "LuaTide",
        "gifWidth": "850",
        "tagline": "App allows you to search for tides around the world.",
        "features": [
            "- Search, access, and save tide related information for your favorites destinations",
            "- Great resource for fishing, surfing and diving",
            "- Learn more about tides and their influence on the environment ",
            "- The API used in this app is no longer supported"
        ],
        "github": "https://github.com/nathalia-lt/Lua-Tide",
        "type": "warning"
    },

    {
        "id": "traderblotter",
        "name": "Trader Blotter",
        "gifWidth": "650",
        "tagline": "An app where you can buy or sell foreign currency in real time.",
        "features": [
            "- Watch exchange rates fluctuate in real time",
            "- Learn about the highest and lowest rates of the day",
            "- Perform buy/sell transactions on demand",
            "- Integrated Newscatcher API to display the latest news from around the world",
        ],
        "github": "https://github.com/nathalia-lt/traderblotter/",
        "deploy": "nathalia-lt.github.io/traderblotter/",
        "type": "error"
    },


]

export default allProjects